/**
 * @module order-summary
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Component, OnDestroy, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ObjectInterface } from '@support/api/common/api-response.interface';

@Component({
  selector: 'tmo-document-error',
  templateUrl: './document-error.component.html',
})
export class DocumentErrorComponent implements OnInit, OnDestroy {
  /**
   * boolean flag to show/hide the modal
   */
  @Input() public displayModal: boolean;
  /**
   * data to be shown on modal
   */
  @Input() public displayData: ObjectInterface;
  /**
   * Event emitter to close the modal
   */
  @Output() private closeModalEvent: EventEmitter<boolean>;
  constructor() {
    this.closeModalEvent = new EventEmitter();
  }

  public ngOnInit(): void {}

  public ngOnDestroy(): void {}

  /**
   * to emit event to close modal
   */
  public closeModal(): void {
    this.closeModalEvent.emit(false);
  }
}
